import Table from '@/components/Table' 
import { ProductMarketResearch } from '@/types/MarketResearch' 
import { useMemo } from 'react'   
import { useTable } from '@/hooks/useTable'
import { createColumnHelper } from '@tanstack/react-table'
import { PlusCircle } from "lucide-react" 
import ButtonWithTooltip from '@/components/ButtonWithTooltip' 
import { useProductInMarketResearchQuery } from '@/queries/useProductInMarketResearchQuery'
import { TableData } from '@/components/Table/type'
import DefaultColumn from '@/components/Table/components/DefaultColumn'
import DadosMestreHeaderActions from '@/pages/MasterData/components/DadosMestreHeaderActions'
import TableRowActions from '@/components/Table/components/TableRowActions'
import DeleteDialog from './components/DeleteDialog'

export type ProductTable = TableData<ProductMarketResearch>

const columnHelper = createColumnHelper<ProductMarketResearch>()

interface props {
    id: number
    onAddProductInMarketResearchDialog: () => void
}

const TableProductsMarketResearch = ({id, onAddProductInMarketResearchDialog}: props) => {   
    const { 
            tableState, 
            setTable,
            onClickDelete,
            isDeleteDialogOpen,
            selectedRow,
            onDeleteDialogClose
        } = useTable<ProductMarketResearch>('')

    const { data, isLoading, isFetching, refetch } = useProductInMarketResearchQuery(Number(id)) 

    const memoData = useMemo(() => data || [], [data])
    const memoColumns = useMemo(
        () => [ 
            columnHelper.accessor('SK_PRODUTO', {
                id: 'SK_PRODUTO',
                header: 'Cod. Produto',
                size: 130,
            }), 
            columnHelper.accessor('DS_PRODUTO', {
                id: 'DS_PRODUTO',
                header: 'Produto',
                size: 440,
            }), 
            columnHelper.accessor('DD_SKU', {
                id: 'DD_SKU',
                header: 'Embalagem',
                size: 100,
            }), 
            columnHelper.accessor('DD_UNIDADE_VENDA', {
                id: 'DD_UNIDADE_MEDIDA',
                header: 'Uni. Venda',
                size: 120,
            }),  
            columnHelper.accessor('DD_MARCA', {
                id: 'DD_MARCA',
                header: 'Marca',
                size: 180,
            }),  
            columnHelper.accessor('DS_DETENTOR', {
                id: 'DS_DETENTOR',
                header: 'Fabricante',
                size: 120,
            }),
            columnHelper.display({
                id: 'Ações',
                cell: ({ row }) => {  
                    return (
                        (
                            <TableRowActions 
                                onClickDelete={() => onClickDelete(row)}
                            />
                        )
                    )
                },
                size: 60,
                enableColumnFilter: false,
                enableSorting: false,
            }),
        ],
        []
    )

    return ( 
        <>
            <Table<ProductTable>
                data={memoData}
                columns={memoColumns}
                getRowId={(row) => row.SK_PRODUTO.toString()}
                isLoading={isLoading}
                isFetching={isFetching}
                getTableInstance={(table) => setTable(table)}   
                tableHeader={(
                    <ButtonWithTooltip
                        className="flex items-center justify-center w-auto gap-2 px-4 rounded-md"
                        tooltipContent={<p>Adicionar</p>}  
                        onClick={() => onAddProductInMarketResearchDialog()}
                        size="sm"
                    >
                    <PlusCircle size={18} />
                        Adicionar produtos
                    </ButtonWithTooltip>
                )}
                tableState={tableState}   
                tableActions={
                    <DadosMestreHeaderActions
                        // onDownload={() => table && onDownload(table)}
                        onRefech={refetch} 
                    />
                }  
                defaultColumn={{
                    cell: ({ getValue }) => (
                        <DefaultColumn>{getValue() as string}</DefaultColumn>
                    ),
                }}
            />  
             {(isDeleteDialogOpen && selectedRow)  && (
                    <DeleteDialog
                        ids={selectedRow.original.SK_PRODUTOS_PESQUISA}
                        nameUser={selectedRow.original.DS_PRODUTO}
                        isOpen={isDeleteDialogOpen}
                        onClose={onDeleteDialogClose}
                    />
            )}
        </>
    )
}

export default TableProductsMarketResearch
